import Phaser from 'phaser';
import { WelcomeScene } from './planets/WelcomeScene';
import { PlanetScene } from './planets/PlanetScene';
import { SimpleScene } from './planets/SimpleScene';
import { AboutScene } from './AboutScene';


// 游戏
let game = new Phaser.Game({
    type: Phaser.AUTO,
    width: window.innerWidth,
    height: window.innerHeight,
    physics: {
      default: 'arcade',
      arcade: {
        gravity: { x: 0, y: 0 },
        debug: false
      }
    },
    scene: [WelcomeScene, SimpleScene, PlanetScene, AboutScene],
});

// 游戏始终全屏，支持横屏
window.addEventListener('resize', () => {
  game.scale.resize(window.innerWidth, window.innerHeight);
});
window.addEventListener('orientationchange', () => {
  game.scale.resize(window.innerWidth, window.innerHeight);
});